<template>
  <div class="input-switch_wrapper">
    <label class="input-switch" :for="inputId">
      {{label}}
      <input
        type="checkbox"
        :id="inputId"
        :checked="value"
        @change="updateModel($event.target.checked)"
      />
      <span class="switch-button"></span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    // Required props
    value: {
      // value for v-model to bind to
      type: Boolean,
      required: true,
    },
    // Optional props
    label: String, // label text
    inputId: String, // id to input and label, cause id on component applies it to div
  },
  methods: {
    updateModel(value) {
      // Imitate what v-model does and emit that to parent component v-model
      this.$emit("input", value);
    },
  },
};
</script>

<style scoped></style>
